import { render, staticRenderFns } from "./voiceShop.vue?vue&type=template&id=c0558cac&scoped=true&"
import script from "./voiceShop.ts?vue&type=script&lang=js&"
export * from "./voiceShop.ts?vue&type=script&lang=js&"
import style0 from "./voiceShop.less?vue&type=style&index=0&id=c0558cac&lang=less&scoped=true&"
import style1 from "./voiceShop2.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0558cac",
  null
  
)

export default component.exports